<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>设备状态</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="车间选择">
					<el-select v-model="workshopId" clearable placeholder="车间选择">
						<el-option v-for="item in workshops" :key="item._id.$oid" :label="item.name" :value="item._id.$oid"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="刷新周期">
					<el-input-number v-model="num" :min="5" :max="10" label="刷新周期"></el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="info">设备状态监控</el-button>
				</el-form-item>
			</el-form>
		</div>

		<device-list v-bind:workshopId="workshopId" v-on:select="handleSelectJT" />

		<div v-if="selectedJT">
			<div class="device-status" v-if="action == ''">
				<el-row :gutter="12">
					<el-col :span="12">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span>机台状态</span>
								<el-button style="float: right; padding: 3px 0" type="text" @click="action = 'DEVICE-STATUS'">最大化</el-button>
							</div>
							<device-status style="height:350px;" :jt_id="selectedJT._id.$oid" />
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span>颜色监控</span>
								<el-button style="float: right; padding: 3px 0" type="text" @click="action = 'DEVICE-COLOR'">最大化</el-button>
							</div>
							<device-color-status style="height:350px;" :jt_id="selectedJT._id.$oid" />
						</el-card>
					</el-col>
				</el-row>
				<br />
				<el-row>
					<el-col :span="24">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span>缺陷图片</span>
							</div>
							<device-defect-images v-on:showDefectImage="handleShowDefectImage" :jt_id="selectedJT._id.$oid" />
						</el-card>
					</el-col>
				</el-row>
			</div>

			<div class="device-view" v-else>
				<el-card class="box-card" v-if="action == 'DEVICE-STATUS'">
					<div slot="header" class="clearfix">
						<span>机台状态</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="action = ''">关闭</el-button>
					</div>
					<device-status :jt_id="selectedJT._id.$oid" />
				</el-card>
				<el-card class="box-card" v-else-if="action == 'DEVICE-COLOR'">
					<div slot="header" class="clearfix">
						<span>机台状态</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="action = ''">关闭</el-button>
					</div>
					<device-color-status :jt_id="selectedJT._id.$oid" />
				</el-card>
				<el-card class="box-card" v-else-if="action == 'DEVICE-DEFECT-IMAGE'">
					<div slot="header" class="clearfix">
						<span>缺陷图</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="action = ''">关闭</el-button>
					</div>
					<device-defect-image-view :jt_id="selectedJT._id.$oid" />
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
	import { workshopRequest } from '@/network/requests/workshop'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import { jtStatusRequest, jtStatusEnum } from '@/network/requests/jtStatus'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import DeviceStatus from '../public/DeviceStatus'
	import DeviceColorStatus from '../public/DeviceColorStatus'
	import DeviceDefectImages from '../public/DeviceDefectImages'
	import DeviceDefectImageView from '../public/DeviceDefectImageView'
	import DeviceList from './DeviceList'
	export default {
		components: {
			DeviceStatus,
			DeviceColorStatus,
			DeviceDefectImages,
			DeviceDefectImageView,
			DeviceList,
		},
		data() {
			return {
				num: 0,
				workshopId: '',
				workshops: [],
				jt_list: [],
				action: '',
				selectedJT: null,
			}
		},
		methods: {
			/**
			 * 选择机台设备。
			 */
			handleSelectJT(jt) {
				this.selectedJT = jt
			},
			/**
			 * 显示机器状态。
			 */
			showDeviceStatus() {
				this.action = 'DEVICE-STATUS'
			},
			handleShowDefectImage() {
				this.action = 'DEVICE-DEFECT-IMAGE'
			},
		},
		mounted() {
			// var outDiv = document.getElementById('out')
			// outDiv.onwheel = function(event) {
			// 	//禁止事件默认行为（此处禁止鼠标滚轮行为关联到"屏幕滚动条上下移动"行为）
			// 	event.preventDefault()
			// 	//设置鼠标滚轮滚动时屏幕滚动条的移动步长
			// 	var step = 50
			// 	if (event.deltaY < 0) {
			// 		//向上滚动鼠标滚轮，屏幕滚动条左移
			// 		this.scrollLeft -= step
			// 	} else {
			// 		//向下滚动鼠标滚轮，屏幕滚动条右移
			// 		this.scrollLeft += step
			// 	}
			// }
		},
		created() {
			workshopRequest.queryAll().then(res => {
				console.log('获取车间', res)
				this.workshops = res
			})
		},
	}
</script>

<style scoped></style>
